import React from 'react';
import { useTranslator } from 'tradera/lang/translate';

type FixedPriceLabelProps = {
    className?: string;
};

export const FixedPriceLabel = ({ className }: FixedPriceLabelProps) => {
    const { t } = useTranslator();
    return (
        <span data-testid="fixedPriceLabel" className={className}>
            {t('itemCard_fixedPrice')}
        </span>
    );
};
